import PropTypes from 'prop-types'
import avatarPlaceholder from '../../../assets/images/mock/default-profile-icon.png'
import SmallMilestoneIcon from '../SmallMilestoneIcon'
import './ProfileAvatar.scss'
import classNames from 'classnames'

const ProfileAvatar = ({ student, withName, avatarClassName, withoutMilestone = false, interactive = true }) => {
  const content = (
    <>
      <div className={classNames('mr-3 smaller-round-image-wrapper', { [avatarClassName]: !!avatarClassName })}>
        <img
          alt='student'
          className='round-image'
          src={student.avatar?.fileUrl || student?.avatar?.small_file_url || avatarPlaceholder}
        />
      </div>
      {!withoutMilestone && (
        <SmallMilestoneIcon fromAvatar className='student-level' division={student.currentFormalDivision || student.current_formal_division}/>
      )}
      {withName && (
        <div className={classNames({ leftMargin: withoutMilestone })}>
          <p className='student-title'>{student.firstName} {student.lastName}</p>
        </div>
      )}
    </>
  )

  if (!interactive) {
    return <div className='d-flex align-items-center student-with-avatar'>{content}</div>
  }

  return (
    <a
      href={`${window.location.origin}/profile/${student.id}`}
      target='_blank'
      className='d-flex align-items-center student-with-avatar'
    >
      {content}
    </a>
  )
}

ProfileAvatar.propTypes = {
  student: PropTypes.object.isRequired,
  withName: PropTypes.bool,
  withoutMilestone: PropTypes.bool,
  avatarClassName: PropTypes.string,
  interactive: PropTypes.bool,
}

export default ProfileAvatar
